
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#F9AB00","d":"M12.389 2.323v13.155c0 1.472 1.015 2.292 2.092 2.292.997 0 2.093-.697 2.093-2.292V2.422c0-1.349-.996-2.192-2.093-2.192s-2.092.93-2.092 2.093"}}),_c('path',{attrs:{"fill":"#E37400","d":"M6.907 9v6.478c0 1.472 1.016 2.292 2.093 2.292.997 0 2.093-.697 2.093-2.292V9.1c0-1.35-.997-2.193-2.093-2.193S6.907 7.837 6.907 9M3.519 17.77a2.093 2.093 0 1 0 0-4.186 2.093 2.093 0 0 0 0 4.186"}})])
          )
        }
      }
    